// §25.2 / §9.1 — Solitaire as an in-process app.
//
// **The one game a guest can play** (D-202): no `requiresAuth`, no Store card, always registered.
// It is what the deliberately limited anonymous desktop has on it that plainly works, which is
// worth more as a showcase than nine cards a visitor cannot open.
//
// This file is the **manifest only** (D-247). The engine, the view and `solitaire.css` live behind
// the `import()` below, so a visitor who never opens Solitaire never downloads it — which is the
// whole of §24.12 and is what keeps the entry chunk inside its budget as the other eight land.
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export const solitaireApp: InProcessApp = createLazyApp({
  app: {
    id: 'solitaire',
    name: 'Solitaire',
    icon: { glyph: 'spade', hue: 145 },
    keywords: ['cards', 'klondike', 'patience', 'game', 'arcade'],
    category: 'Arcade',
    // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
    group: 'Cards',
    // No `requiresAuth` — D-202. Deliberate, and asserted by a test so nobody "consistency-fixes" it.
    window: { width: 900, height: 640, minWidth: 640, minHeight: 480, multiWindow: false },
    jumpList: [
      { id: 'new-game', label: 'New game' },
      { id: 'draw-3', label: 'Draw three' },
    ],
  },
  load: () => import('./Solitaire'),
});
